import Modal from './Modal';
import append from './__helper__/append';
import alert from './alert';

Modal.append = append;
Modal.alert = alert;

export default Modal;
